module.exports = __webpack_public_path__ + "img/delete.fd348e9d.svg";